import { FC, useEffect } from "react";
import format from "../../../../../utilities/formatNumbers";
import { isNum } from "../../../../../utilities/typeGuard";

interface TaxRecalculatedPriceCellProps {
  year?: number | null;
  price?: number | null;
  vehicleYear?: number | null;
  value?: number | null;
  onChange?: (v: number | null) => void;
}

const TaxRecalculatedPriceCell: FC<TaxRecalculatedPriceCellProps> = ({ year, price, vehicleYear, value, onChange }) => {
  useEffect(() => {
    let nextValue = 0;
    if (isNum(vehicleYear) && isNum(price) && isNum(year) && year > 999) {
      let diff = year - vehicleYear;
      if (diff > 4) diff = 4;
      if (diff < -4) diff = -4;
      diff = diff / 10 || 0;
      nextValue = Math.round(price - price * diff);
    }
    onChange && onChange(nextValue);
  }, [year, price, vehicleYear]);

  return <span>{isNum(value) ? format.number(value) : "-"}</span>;
};

export default TaxRecalculatedPriceCell;
